import styled from 'styled-components'

export const TableWrapper = styled.table`
  width: 100%;
  max-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 14px;
  overflow: hidden; /* Ensures the border-radius applies to the entire table */
  margin-bottom: 24px;

  td {
    padding: 16px 12px;
    text-align: left;
  }

  th {
    background-color: ${({ theme }) => theme.bg1};
    font-weight: 600;
    color: #c3c5cb;
    padding: 16px 12px;
  }

  tr {
    transition: background-color 0.3s;
    &:hover {
      background-color: ${({ theme }) => theme.bg2};
    }
  }

  tbody tr {
    background-color: ${({ theme }) => theme.bg0};
  }
`

export const InputTextWrapper = styled.div`
  padding: 12px;
  background: ${({ theme }) => theme.bg0};
  border-radius: 14px;
  display: flex;
  gap: 12px;
  align-items: center;
  transition: all 300ms;
  &:hover {
    background: ${({ theme }) => theme.bg1};
  }
`

export const InputText = styled.input`
  all: unset;
  flex: 1;
`

export const CancelButton = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 2px;
  background: ${({ theme }) => theme.bg2};
  border-radius: 8px;
  transition: all 300ms;

  &:hover {
    background: ${({ theme }) => theme.bg3};
  }
`

export const GridContainerForCard = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 1080px) {
    grid-template-columns: 2fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const LeverageItem = styled.div`
  border-radius: 14px;
  background: ${({ theme }) => theme.bg1};
  padding: 20px;

  .responsive-text {
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`
